import { IAddressChangeViewModel } from '../types/addressChangeViewModel'

export class AddressChangeViewModel implements IAddressChangeViewModel
{
	address1: string = ''
    address2: string = ''
    city: string = ''
    province: string = ''
    postalCode: string = ''
    leaseNumber: string = ''
    isActiveLease: boolean = false
    hasExistingAddressChangeRequest: boolean = false
    existingAddressChangeRequestId: string = ''
    referenceNumber: string = ''
}